// Footer.js
import React from "react";

function Footer() {
  return (
    <footer style={{ background: "#333", color: "white", padding: "10px", textAlign: "center" }}>
      <p> Copyright &copy; 2025 Goteborg Indian Muslims Association (GIMA) All Rights Reserved.</p>
    </footer>
  );
}

export default Footer;